/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';
import './animation047.less';

interface IAnimation047Props {
  columns: any[];
  data: any[];
  className?: string | null;
  onCompleted?: () => void;
}

const Animation047: React.FunctionComponent<IAnimation047Props> = ({
  columns,
  data,
  className,
  onCompleted,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= data.length + 4) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation047 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  return (
    <div className={`component animation047 ${className}`}>
      <div className="animation047-title">
        {columns.map((x, idx) => (
          <div
            key={idx}
            className={`subtitle subtitle${idx} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
          >
            <img
              className="subtitle-icon"
              key={`icon${idx}`}
              src={getImg(x.icon)}
              alt=""
            />
            <div className="subtitle-content" key={`title${idx}`}>
              {x.title}
            </div>
            <img
              className="click-point"
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
          </div>
        ))}
      </div>

      <div className="animation047-content">
        {data.map((x, index) => (
          <div
            key={`content${index}`}
            className={`animation047-item animation047-item${index} animation ${
              play >= index + 3 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
          >
            {columns.map((col, colIndex) => (
              <div className="sub-item" key={`${index}-${colIndex}`}>
                {colIndex < columns.length - 1 ? (
                  x[col.key]
                ) : (
                  <ul>
                    {x[col.key].map((dt: string, dtIdx: number) => (
                      <li key={dtIdx}>{dt}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation047;
